import { Component } from '@angular/core';
import { PageHeaderComponent } from '@components/page-header/page-header.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'md-pricing-carcass-collection-customers-page',
  standalone: true,
  imports: [PageHeaderComponent, TranslateModule],
  templateUrl: './pricing-carcass-collection-customers-page.component.html',
  styleUrl: './pricing-carcass-collection-customers-page.component.scss'
})
export class PricingCarcassCollectionCustomersPageComponent {}
